export const Colors = {
  //
  GreyBlue: "#294273",

  //
  Waikawa: "#5d7097",

  // A very dark navy, used for backgrounds or darkening overlays.
  Midnight: "#0B1F3C",

  // A dark navy. Used as primary text color and dark background color.
  Astronaut: "#2c4d76",

  // This needs a proper name
  Blue: "#2a5dbd",

  // A strong, punchy blue. Suitable for primary actions.
  Havelock: "#4e8ad4",

  // Again needs a proper name
  Glacier: "#EBF1FB",

  // A strong, punchy green. Suitable for primary actions that feel "positive"
  // or "completing".
  Mantis: "#58B55c",

  // A soft, blue-tinged, light grey. Suitable for non-primary actions.
  Athens: "#e1e6ea",

  // A subtle off-white. Suitable for contrasting sections vs. white.
  Porcelain: "#f6f7f8",

  // Used for borders on cards and similar forms, and horizontal line dividers
  Border: "#00000020",
};

export const Gradients = {
  Auctions: "linear-gradient(154.32deg, #FFF1D2 0%, #FFE0F8 100%)",
  Breaks:
    "linear-gradient(#ffffffc0, #ffffffc0), linear-gradient(135deg, #ee9165, #b56ce7)",
  Channels:
    "linear-gradient(to bottom right, rgb(28 166 131 / 25%), rgb(132 106 227 / 25%))",
  Nft: "linear-gradient(0deg, #9A52C5 0%, #53339B 100%)",
  Placeholder: "linear-gradient(135deg, #9A52C520 0%, #53339B20 100%)",
};

export const CONTENT_WIDTH = "74rem";

export const Breakpoints = {
  Mobile: "45rem",
  Large: "65rem",
};

export const Borders = {
  Live: "1px solid #c9d8f1",
  Nft: "1px solid #cad6ef",
  Standalone: `1px solid ${Colors.Border}`,
  User: `1px solid rgb(31 31 35 / 20%)`,
};

export const NewColors = {
  Black: "#1f1f23",
  Green: "#1ca683",
  Negative: "#dd6161",
  Purple: "#846ae3",

  Glacier: "#f1effa",
  GlacierDarkened: "#ebe7fa",
  GlacierShadow: "#ebe7fa40",

  DiscordBlurple: "#5865F2",
  DiscordBlurpleDarkened: "#3d48c0",
  DiscordBlurpleShadow: "#3d48c040",

  NegativeDarkened: "#c23737",
  NegativeShadow: "#c2373740",

  // Green
  Primary: "#1ca683",
  PrimaryDarkened: "#188a6e",
  PrimaryOverlay: "#1ca68320",
  PrimaryShadow: "#188a6e60",

  // Purple
  Secondary: "#846ae3",
  SecondaryDarkened: "#6753b2",
  SecondaryOverlay: "#846ae320",
  SecondaryShadow: "#6753B260",

  // Backgrounds
  Deadfill: "#e9edf8",

  // Text
  TextShout: "#292431",
  TextSpeak: "#292431c0",
  TextWhisper: "#29243180",
};
